/// <reference path="./object-click-handler" />

export class ObjectClickHandler {

	static handlers = []; // jshint ignore:line
	static objects  = [];

	static acts     = {};
	static actFns   = {};

	acts   = [];
	object = null;

	get isClickable() {
		return this.acts.length > 0;
	}

	constructor( acts = [], object = undefined ) {

		ObjectClickHandler.handlers.push( this );

		this.setActs( acts );

		if (object) this.attachTo( object );
	}

	setActs( acts ) {
		this.acts = [];

		if (angular.isObject( acts )) {

			if (!Array.isArray( acts )) {
				acts = [ acts ];
			}

			for (var i in acts) {
				this.pushAct( acts[ i ] );
			}
		}
	}

	pushAct( act ) {
			
		var _act = { conditions: {}, fn: angular.noop, arguments: [] };

		if (angular.isString( act )) {
			act = { fn: act };
		}

		if (angular.isFunction( act )) {
			act = { fn: act };
		}

		if (angular.isObject( act )) {

			if (Array.isArray( act.conditions )) {

				for (var i in act.conditions) {

					if (act.conditions[i] != null) {
						_act.conditions[ act.conditions[ i ]] = true
					}
				}
			} else if (angular.isObject( act.conditions )) {

				_act.conditions = act.conditions;

			} else if (angular.isString( act.conditions )) {

				_act.conditions[ act.conditions ] = true;
			}

			if ("none" in _act.conditions) {
				delete _act.conditions.none;
			}

			/*****/

			if (angular.isString( act.fn ) || angular.isFunction( act.fn )) {
				_act.fn = act.fn;
			}
			
			/*****/

			if (Array.isArray( act.arguments )) {
				_act.arguments = act.arguments;
			}
		}
			
		if (angular.isString( _act.fn ) && ObjectClickHandler.actFns[ _act.fn ]) {
			this.acts.push( _act );
		} else if (angular.isFunction( _act.fn ) && _act.fn != angular.noop) {
			this.acts.push( _act );
		}
	}

	attachTo( object ) {

		if (this.object) {

			var object_idx = ObjectClickHandler.objects.indexOf( this.object );

			if (object_idx != -1) {
				ObjectClickHandler.objects.splice( object_idx, 1 );
			}

			delete this.object.$clickHandler;
		}

		if (object) {

			object.$clickHandler = this;

			this.object = object;

			ObjectClickHandler.objects.push( this.object );

		}
	}

	run( event ) {

		// Pitäisi saada sisälle serviceen tai johonkin!
		var injector = angular.element( document.body ).injector( ).get;

		for (var i in this.acts) try {

			var act = this.acts[ i ];
			var conditions = act.conditions;

			if (conditions) {

				if (conditions.inEditor) {
					if (!injector("gameSceneService").inEditor()) continue;
				}

				if (conditions.notInEditor) {
					if (injector("gameSceneService").inEditor()) continue;
				}

				if (conditions.nothingSelected) {
					if (injector("entitySelectionService").selected_entity) continue;
				}

				if (conditions.rightClick) {
					if (event.button != 2) continue;
				} else {
					if (event.button != 0) continue;
				}
			}
			
			var fn;

			if (angular.isString( act.fn ) && ObjectClickHandler.actFns[ act.fn ]) {

				fn = ObjectClickHandler.actFns[ act.fn ];

			} else if (angular.isFunction( act.fn )) {

				fn = act.fn;

			}

			
			if (angular.isFunction( fn )) {
				var argv = [ event ];

				if (act.arguments) {
					argv.push.apply( argv, act.arguments );
				}

				fn.apply( fn, argv );

			} else throw new Error( "Invalid fn" );

			return true;

		} catch (error) {
			console.error( error );
		}
	}
	
	static solveIntersectHandlerFromScreenPoint( x, y ) {

		return ObjectClickHandler.solveIntersectHandlerFromIntersects( screenIntersects( x, y ))
	}

	static solveIntersectHandlerFromIntersects( intersects ) {

		for ( var i = 0; i < intersects.length; i++) {

			var handler = ObjectClickHandler.solveHandlerFromIntersect( intersects[i] );

			if (handler) {
				intersects[ i ].handler = handler;
				return intersects[ i ];
			}
		}
	}

	static solveHandlerFromScreenPoint( x, y ) {

		return ObjectClickHandler.solveHandlerFromIntersects( screenIntersects( x, y ));
	}

	static solveHandlerFromIntersects( intersects ) {

		for ( var i = 0; i < intersects.length; i++) {

			var handler = ObjectClickHandler.solveHandlerFromIntersect( intersects[i] );

			if (handler) return handler;
		}
	}

	static solveHandlerFromIntersect( intersect ) {

		if (!intersect.object) return;

		if (!intersect.face) return;

		// Jos kohde on asetettu läpinäkyväksi intersect-tarkistukselle, ohitetaan se
		if (intersect.object.userData && intersect.object.userData.intersectTransparent) return;

		var mesh = intersect.object;

		while (mesh) {

			var obj = mesh;

			if (!obj.$clickHandler && obj.userData) {

				if (obj.userData.type == "oeuvre") {
					obj = obj.userData.obj;
				} else if (obj.userData.type == "dragHandle") {
					if (obj.userData.dragHandle) {
						obj = obj.userData.dragHandle;
					} else {
						obj = obj.$parent;
					}
				} else if (obj.userData.type == "additionalObject") {
					obj = obj.userData.additionalObject;
				}
			}

			if (obj.$clickHandler) {
				return obj.$clickHandler;
			}

			mesh = mesh.parent;
		}
	}
}

export class ObjectClickHandlerAction {

	static buildDefaultArguments( fn, act, assets ) {  

        try {
            switch (fn) {
                case "setPlayerPositionRotation":
					let { player } = assets;
                    return [ player.pos.toArray(), player.av, player.ah ];
                    break;
                    
                case "openOeuvreInfoModal":
					let { handler } = act;
                    return [ handler.object.uid ];
                    break;

                case "showTextContextMenu":
                    return [ "", "", { size: "" }];
                    break;
            }
        } catch (error) {
            console.error( error );
        }

		return [];
	}
}